export default __webpack_public_path__ + "static/media/hand-left-back.60e4cc8b.png";